module.exports = __webpack_public_path__ + "static/media/AAVEe.aadf289d.svg";